import * as React from "react"
const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={25}
        height={24}
        fill="none"
        cursor="pointer"

        {...props}
    >
        <rect
            width={24}
            height={24}
            x={24.5}
            y={24}
            fill="#005586"
            rx={12}
            transform="rotate(-180 24.5 24)"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="m16.5 14-4-4-4 4"
        />
    </svg>
)
export default SvgComponent